import _filter from 'lodash/filter';
import { chatSdk } from '../../api/chat-sdk';
export var getMissingParticipantIds = function (participantIds) {
    var state = chatSdk.store.getState();
    return _filter(participantIds, function (id) { return !state.participants.byId[id]; });
};
